import React, { useState } from "react";
import Snackbar from "../../../../common/Snackbar";
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import AccordionComponent from "../../../../common/Accordion";
import DataTable from "../../../../common/DataTable";
import {
  cancelInvoice,
  cancelInvoiceLineItem,
} from "../../../../services/InvoiceReportsApi";

const InvoiceCancel = ({
  show,
  onHide,
  selectedLineItem,
  clientInvoiceSummaries,
  drawerTitle,
  activeTab,
}: any) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [cancelReason, setCancelReason] = useState<string>("");

  const mainParentId = selectedLineItem?.[0]?.mainParentId;

  const matchedInvoice = clientInvoiceSummaries.find(
    (inv: any) => inv.id === mainParentId,
  );

  const invoiceInfoId = matchedInvoice?.data?.invoiceInfoId;
  const clientName = matchedInvoice?.data?.clientName;

  const qmeDoctorName = selectedLineItem?.[0]?.qmeDoctorName;

  const [invoiceReportsKey, setInvoiceReportsKey] = useState<string | null>(
    null,
  );

  const onSave = async () => {
    try {
      // if (!cancelReason) {
      //   setError("error");
      //   setSnackbarMessage("Please write comment.");
      //   setSnackbarOpen(true);
      //   return;
      // }

      if (!selectedLineItem?.length) return;

      let response;

      if (drawerTitle === "Cancel Invoice") {
        const invoiceId = selectedLineItem?.[0]?.invoiceId;

        const payload = {
          invoiceIdsCsv: invoiceId?.toString(),
          cancelComments: cancelReason,
          cancelInvoiceFor: activeTab,
        };

        response = await cancelInvoice(payload);
      } else if (drawerTitle === "Cancel Invoice Line Item") {
        const uniqueKeyLookupIdCsv = selectedLineItem
          .map((item: any) => item.uniqueKey_LookupId)
          .filter(Boolean)
          .join(",");

        const payload = {
          invoiceId: selectedLineItem?.[0]?.invoiceId,
          invoiceIdsCsv: uniqueKeyLookupIdCsv,
          cancelComments: cancelReason,
        };

        response = await cancelInvoiceLineItem(payload);
      }

      if (response?.isSuccess) {
        setError("success");
        setSnackbarMessage("Invoice Cancelled Successfully");
        setSnackbarOpen(true);
      } else {
        setError("error");
        setSnackbarMessage("Falied to cancel the invoice");
        setSnackbarOpen(true);
      }
      setTimeout(() => {
        onHide?.("Save");
      }, 1000);
    } catch (e) {
      console.log("Error cancelling data", e);
    }
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={invoiceReportsKey}
      onSelect={(key) => setInvoiceReportsKey(key as string)}
    />
  );

  return (
    <>
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="recordList"
      >
        <Modal.Body className="fw-bold text-center modelheading mb-0 pb-0">
          <p className="mb-1">
            Are you sure you want to Cancel – Generated Invoice?
          </p>

          <p className="appointment-count-info fs-13 text-danger mb-1">
            Once canceled, this invoice will no longer be billable.
          </p>
          <Row className="mt-1">
            <Col
              sm={12}
              className="mt-1 notemultiline notemultilinerushnote  mb-3"
            >
              <MultilineTextBox
                label="Cancellation Reason"
                style={{ minHeight: "70px !important " }}
                name="reason"
                value={cancelReason ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value?.trimStart();
                  value = value.replace(/ {2,}/g, " ");
                  setCancelReason(value);
                }}
                maxLength={100}
              />
            </Col>
          </Row>
          {selectedLineItem.length == 1 && (
            <>
              {configurationAccordion([
                {
                  title: "List",
                  content: (
                    <div className="table-responsive border-0 mb-2 invoiceCancelAreapopup">
                      <Table>
                        <thead>
                          <tr>
                            <th style={{ width: "15%" }}>Patient Name</th>
                            <th style={{ width: "10%" }}>Task</th>
                            <th style={{ width: "10%" }}>No of Pages</th>
                            <th style={{ width: "10%" }}>No. of Lines</th>
                            <th style={{ width: "10%" }}>Rate Type</th>
                            <th>Date Uploaded On | By</th>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th style={{ width: "12%" }}>Invoice Status</th>
                          </tr>
                        </thead>

                        <tbody className="invoiceCancelAreapopup_grid">
                          {/* Invoice Info Row */}
                          <tr style={{ backgroundColor: "#f1f3f5" }}>
                            <td colSpan={9} style={{ textAlign: "left" }}>
                              {invoiceInfoId} | {clientName}
                            </td>
                          </tr>

                          {/* QME Doctor Row */}
                          <tr style={{ backgroundColor: "#f8f9fa" }}>
                            <td colSpan={9} style={{ textAlign: "left" }}>
                              {qmeDoctorName}
                            </td>
                          </tr>

                          {/* Actual Line Item Data */}
                          {selectedLineItem.map((item: any, index: number) => (
                            <tr key={index}>
                              <td>{item.patientName}</td>
                              <td>{item.taskName}</td>
                              <td>{item.noOfPages}</td>
                              <td>{item.noOfLines}</td>
                              <td>{item.rateType}</td>
                              <td>
                                <span className="truncatetwoline">
                                  {item.dateUploaded}
                                </span>
                              </td>
                              <td>{item.rate}</td>
                              <td>{item.amount}</td>
                              <td>{item.invoiceStatus}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ),
                },
              ])}
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end pt-1 pb-1">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={onHide}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={onSave}
            // disabled={isSaving}
          >
            <span className="material-icons mx-1">check</span>
            {drawerTitle === "Cancel Invoice Line Item"
              ? "Confirm & Regenerate"
              : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InvoiceCancel;
